import {
  call, put, takeLatest, all, select, takeEvery
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions, actionCreators } from 'react/api/actions/photoGallery';
import * as selectors from 'react/api/selectors/photoGallery';

function* fetchLargePhotoApi(photoId) {
  const url = `/Photo/${photoId}/Image`;
  return yield call(defaultFetch, url);
}

function* fetchLargePhoto(action) {
  const photoId = action.payload;
  const response = yield call(fetchLargePhotoApi, photoId);
  if (!response?.error) {
    yield put(actionCreators.fetchLargePhotoSucceeded(response));
  } else {
    yield put(actionCreators.fetchLargePhotoFailed(response.error));
  }
}

function* watchFetchLargePhoto() {
  yield takeEvery(actions.fetchLargePhoto, fetchLargePhoto);
}

function* setCurrentPhoto(action) {
  const photoId = action.payload;
  if (photoId) {
    const photoExists = yield select(selectors.getCurrentPhoto);
    if (!photoExists) {
      yield put(actionCreators.fetchLargePhoto(photoId));
    }
  }
}

function* watchSetCurrentPhotoId() {
  yield takeLatest(actions.setCurrentPhotoId, setCurrentPhoto);
}

function* photoGallery() {
  yield all([
    watchFetchLargePhoto(),
    watchSetCurrentPhotoId()
  ]);
}

export default photoGallery;
